import { Tabs } from 'antd';
import React, { Fragment, useState } from 'react'
import { AmindForControlSmsProviderTab } from './AdminForControlSmsProviderTab';
import { AdminForControlSmsPartnerTab } from './AdminForControlSmsPartnerTab';

export const AdminSmsForControlPage = () => {
    const [tabDefaulf, setTabDefaulf] = useState<any>('provider_tab');
    const onChange = (key: string) => {
        setTabDefaulf(key);
    };

    return (
        <Fragment>
            <Tabs
                activeKey={tabDefaulf}
                onChange={onChange}
                items={[
                    {
                        label: 'Nhà cung cấp',
                        key: 'provider_tab',
                        children: <AmindForControlSmsProviderTab />,
                    },
                    {
                        label: 'Đối tác',
                        key: 'partner_tab',
                        children: <AdminForControlSmsPartnerTab />,
                    }
                ]}
            />
        </Fragment>
    )
}
